import styled from 'styled-components/macro';

export const BottomLink = styled.div`
  @media screen and (max-width: 377px) {
    flex-direction: column;
    & > * {
      margin: 0;
    }
    & > span {
      margin-right: 0 !important;
      margin-bottom: 8px;
    }
  }
`;
